import type { RouteRecordRaw } from 'vue-router'
import routerNames from './routerNames'
import breadcrumbNames from './breadcrumbName'
import routerTitle from './RouterTitle'

const AdminManagerRouter: RouteRecordRaw = {
  path: '/',
  meta: {
    requiresAuth: true,
    breadcrumb: breadcrumbNames.SETTING
  },
  component: () => import('@/layouts/DefaultLayout.vue'),
  children: [
    {
      name: routerNames.MY_ACCOUNT,
      path: 'account',
      component: () => import('@/views/Setting/MyAccountView.vue'),
      meta: {
        title: routerTitle.MY_ACCOUNT,
        breadcrumb: breadcrumbNames.SETTING
      },
      children: [
        {
          name: routerNames.MY_ACCOUNT_EDIT_INFO,
          path: 'edit-info',
          component: () => import('@/views/Setting/EditMyAccountView.vue'),
          meta: {
            title: routerTitle.MY_ACCOUNT_EDIT_INFO,
            breadcrumb: breadcrumbNames.SETTING
          }
        },
        {
          name: routerNames.MY_ACCOUNT_EDIT_PASSWORD,
          path: 'edit-password',
          component: () => import('@/views/Setting/EditMyAccountView.vue'),
          meta: {
            title: routerTitle.MY_ACCOUNT_EDIT_PASSWORD,
            breadcrumb: breadcrumbNames.SETTING
          }
        },
        {
          name: routerNames.MY_ACCOUNT_CHANGE_EMAIL,
          path: 'edit-email',
          component: () => import('@/views/Setting/ChangeEmailView.vue'),
          meta: {
            title: routerTitle.MY_ACCOUNT_CHANGE_EMAIL,
            breadcrumb: breadcrumbNames.SETTING
          }
        },
        {
          name: routerNames.MY_ACCOUNT_CHANGE_EMAIL_CONFIRM,
          path: 'confirm-email',
          component: () => import('@/views/Setting/ConfirmChangeEmailView.vue'),
          meta: {
            title: routerTitle.MY_ACCOUNT_CHANGE_EMAIL_CONFIRM,
            breadcrumb: breadcrumbNames.SETTING
          }
        },
        {
          name: routerNames.MY_ACCOUNT_LEAVE,
          path: 'leave',
          component: () => import('@/views/Setting/LeaveAccountView.vue'),
          meta: {
            title: routerTitle.MY_ACCOUNT_LEAVE,
            breadcrumb: breadcrumbNames.SETTING
          }
        }
      ]
    },
    {
      name: routerNames.MESSAGE,
      path: 'message',
      component: () => import('@/views/Setting/ChatView.vue'),
      meta: {
        title: routerTitle.MESSAGE,
        breadcrumb: breadcrumbNames.SETTING
      }
    }
  ]
}

export default AdminManagerRouter
